import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function IsolationComblesPage() {
  const travail = getTravailStub('isolation-combles');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
